import { createClient } from '@supabase/supabase-js';

if (!process.env.REACT_APP_SUPABASE_URL) {
    throw new Error('Supabase URL missing');
}
if (!process.env.REACT_APP_SUPABASE_ANON_KEY) {
    throw new Error('Supabase key missing');
}

export const supabase = createClient(
    process.env.REACT_APP_SUPABASE_URL,
    process.env.REACT_APP_SUPABASE_ANON_KEY,
    {
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true
        }
    }
);

// Published stories are public. Do not make their requests wait for a stored
// login session or use an expired user's token instead of the public key.
export const publicSupabase = createClient(
    process.env.REACT_APP_SUPABASE_URL,
    process.env.REACT_APP_SUPABASE_ANON_KEY,
    { auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false } }
);

console.log('supabaseClient: Initialized with URL', process.env.REACT_APP_SUPABASE_URL);

// Quick connectivity check (development only)
if (process.env.NODE_ENV === 'development') {
  fetch(`${process.env.REACT_APP_SUPABASE_URL}/rest/v1`, {
    headers: { apikey: process.env.REACT_APP_SUPABASE_ANON_KEY || '' }
  })
    .then((r) => console.log('supabaseClient: REST health status', r.status))
    .catch((err) => console.error('supabaseClient: REST connectivity error', err));
}
